<template>
  <div>
    <!-- 直播赛事表单 -->
    <el-form ref="liveForm" :model="liveForm" :rules="rules" label-width="160px" :validate-on-rule-change="false">
      <el-form-item label="直播时间：" prop="liveTime">
        <el-date-picker v-model="liveForm.liveTime" size="small" clearable type="datetimerange" format="yyyy-MM-dd HH:mm"
          value-format="yyyy-MM-dd HH:mm:ss" :picker-options="pickerOptions" range-separator="至"
          start-placeholder="直播开始日期" end-placeholder="直播结束日期" :default-time="['00:00:00', '23:59:59']"></el-date-picker>
      </el-form-item>
      <el-form-item label="队伍信息：" prop="teamA">
        <div class="teamInfo">
          <div class="left">
            <el-input v-model="liveForm.teamA" maxlength="99" size="small" clearable placeholder="输入文案"></el-input>
            <el-input v-model="liveForm.teamAScore" size="small" clearable placeholder="输入数字"></el-input>
          </div>
          <div class="right">
            <el-upload class="avatar-uploader" :before-upload="fileCheck" :http-request="(params) => upload(params, 1)"
              :show-file-list="false">
              <el-image v-if="liveForm.teamAImg" :src="liveForm.teamAImg" fit="contain" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
            <el-radio-group v-model="liveForm.teamAImgSelectWidth">
              <el-radio label="300">小图：300px (推荐)</el-radio>
              <el-radio label="700">大图：700px (推荐)</el-radio>
              <el-radio :label="-1" class="custom-width">自定义图片宽度
                <el-popover placement="top" width="200" trigger="hover" content="如果输入了自定义图片宽度，以自定义图片宽度为准">
                  <i class="el-icon-question tip-icon" slot="reference" style="color: #507dc5;"></i>
                </el-popover>
              </el-radio>
            </el-radio-group>
            <el-input v-if="liveForm.teamAImgSelectWidth === -1" size="small" v-model="liveForm.teamAImgWidth"
              placeholder="请输入图片宽度(单位px)" clearable></el-input>
          </div>
        </div>
      </el-form-item>
      <el-form-item label=" " prop="teamB">
        <div class="teamInfo">
          <div class="left">
            <el-input v-model="liveForm.teamB" maxlength="99" size="small" clearable placeholder="输入文案"></el-input>
            <el-input v-model="liveForm.teamBScore" size="small" clearable placeholder="输入数字"></el-input>
          </div>
          <div class="right">
            <el-upload class="avatar-uploader" :before-upload="fileCheck" :http-request="(params) => upload(params, 2)"
              :show-file-list="false">
              <el-image v-if="liveForm.teamBImg" :src="liveForm.teamBImg" fit="contain" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
            <el-radio-group v-model="liveForm.teamBImgSelectWidth">
              <el-radio label="300">小图：300px (推荐)</el-radio>
              <el-radio label="700">大图：700px (推荐)</el-radio>
              <el-radio :label="-1" class="custom-width">自定义图片宽度
                <el-popover placement="top" width="200" trigger="hover" content="如果输入了自定义图片宽度，以自定义图片宽度为准">
                  <i class="el-icon-question tip-icon" slot="reference" style="color: #507dc5;"></i>
                </el-popover>
              </el-radio>
            </el-radio-group>
            <el-input v-if="liveForm.teamBImgSelectWidth === -1" size="small" v-model="liveForm.teamBImgWidth"
              placeholder="请输入图片宽度(单位px)" clearable></el-input>
          </div>
        </div>
      </el-form-item>
      <el-form-item label="显示顺序：" prop="displayOrder">
        <el-input v-model="liveForm.displayOrder" size="small" clearable placeholder="按照顺序进行显示，相同数字按时间排序"></el-input>
      </el-form-item>
      <el-form-item label="描述：" prop="description">
        <el-input v-model="liveForm.description" maxlength="99" size="small" clearable placeholder="输入文案"></el-input>
      </el-form-item>
      <el-form-item label="关联应用：" prop="thirdPartyAppId">
        <el-select v-model="liveForm.thirdPartyAppId" size="small" clearable placeholder="请选择">
          <el-option v-for="item in thirdPartyAppList.value" :key="item.id" :label="item.label"
            :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="单片跳转链接：">
        <br />
      </el-form-item>
      <div class="link-container">
        <el-form-item label="Android_Scheme：" prop="androidScheme">
          <el-input v-model="liveForm.androidScheme" maxlength="999" size="small" clearable
            placeholder="输入Android端的Scheme链接"></el-input>
        </el-form-item>
        <el-form-item label="Android_app_link：" prop="androidAppLink">
          <el-input v-model="liveForm.androidAppLink" maxlength="999" size="small" clearable
            placeholder="输入Android端的通用跳转链接"></el-input>
        </el-form-item>
        <el-form-item label="Android_pad_Scheme：" prop="androidPadScheme">
          <el-input v-model="liveForm.androidPadScheme" maxlength="999" size="small" clearable
            placeholder="输入Android_pad端的Scheme链接"></el-input>
        </el-form-item>
      </div>
      <br />
      <div class="link-container">
        <el-form-item label="iOS_Scheme：" prop="iosScheme">
          <el-input v-model="liveForm.iosScheme" maxlength="999" size="small" clearable
            placeholder="输入iOS端的Scheme链接"></el-input>
        </el-form-item>
        <el-form-item label="iOS_app_link：" prop="appLink">
          <el-input v-model="liveForm.appLink" maxlength="999" size="small" clearable
            placeholder="输入iOS端的通用跳转链接"></el-input>
        </el-form-item>
        <el-form-item label="iPad_Scheme：" prop="ipadScheme">
          <el-input v-model="liveForm.ipadScheme" maxlength="999" size="small" clearable
            placeholder="输入ipad端的Scheme链接"></el-input>
        </el-form-item>
      </div>
      <br />
      <el-form-item label="备注" prop="remark">
        <el-input show-word-limit maxlength="9999" type="textarea" size="small" v-model="liveForm.remark"
          placeholder="请输入备注" clearable></el-input>
      </el-form-item>
      <el-form-item label="状态" prop="status">
        <el-radio-group v-model="liveForm.status">
          <el-radio :label="1">生效</el-radio>
          <el-radio :label="0">失效</el-radio>
        </el-radio-group>
      </el-form-item>
      <!-- 生效模式 -->
      <el-form-item v-if="liveForm.status === 1" label="选择" prop="effectMode">
        <!-- 立即生效 1  指定时间生效 2 -->
        <el-radio-group v-model="liveForm.effectMode">
          <el-radio :label="1">立即生效</el-radio>
          <el-radio :label="2">指定时间生效</el-radio>
        </el-radio-group>
      </el-form-item>
      <!-- 生效时间 -->
      <el-form-item v-if="liveForm.status === 1 && liveForm.effectMode === 2" label="生效时间" prop="effectTime">
        <el-date-picker size="small" :picker-options="{
          disabledDate(time) {
            return time.getTime() < Date.now() - 8.64e7;
          },
        }
          " v-model="liveForm.effectTime" value-format="yyyy-MM-dd HH:mm:ss" type="datetimerange" range-separator="至"
          start-placeholder="生效开始时间" end-placeholder="生效结束时间" clearable>
        </el-date-picker>
      </el-form-item>
      <!-- 保存和取消按钮 -->
      <div class="btn-container" style="text-align: right; margin-top: 20px">
        <el-button size="small" type="primary" @click="save">保存</el-button>
        <el-button size="small" @click="cancel">取消</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import axios from 'axios';
import _ from 'lodash'
import Message from '@/components/Message';
import { formatAddLive, formatEditLive } from "../utils/index"
import { updateListContent } from '@/api/listContentManage/index'
import { validateTeamAImageWidth, validateTeamBImageWidth, updateTeamAImgUrl, updateTeamBImgUrl } from "../utils/index"

export default {
  name: 'WebSaaSLiveForm',
  inject: ['thirdPartyAppList'],
  data() {
    return {
      /** 日期选择配置 */
      pickerOptions: {
        onPick({ maxDate, minDate }) {
          if (maxDate) {
            maxDate.setSeconds(0);
          }
          if (minDate) {
            minDate.setSeconds(0);
          }
        }
      },
      /** 直播赛事表单 */
      liveForm: {
        /** 直播时间 */
        liveTime: [],
        /** 左队伍信息 */
        teamA: '',
        /** 左队伍得分 */
        teamAScore: '',
        /** 左队伍图标 */
        teamAImg: '',
        /** 左队伍图片选择宽度 */
        teamAImgSelectWidth: '300',
        /** 左队伍图片自定义宽度 */
        teamAImgWidth: '',
        /** 右队伍信息 */
        teamB: '',
        /** 右队伍得分 */
        teamBScore: '',
        /** 右队伍图标 */
        teamBImg: '',
        /** 右队伍图片选择宽度 */
        teamBImgSelectWidth: '300',
        /** 右队伍图片自定义宽度 */
        teamBImgWidth: '',
        /** 显示顺序 */
        displayOrder: '',
        /** 描述 */
        description: '',
        /** 关联应用 */
        thirdPartyAppId: '',
        /** 单片跳转链接 */
        /** 安卓scheme */
        androidScheme: '',
        /** 安卓app_link */
        androidAppLink: '',
        /** 安卓pad_scheme */
        androidPadScheme: '',
        /** ios_scheme */
        iosScheme: '',
        /** ios_app_link */
        appLink: '',
        /** ipad_scheme */
        ipadScheme: '',
        /** 备注 */
        remark: '',
        /** 状态 */
        status: null,
        /** 生效模式 1：立即生效；2：指定时间生效 */
        effectMode: "",
        /** 生效时间 */
        effectTime: [],
      },
      /** 验证规则 */
      rules: {
        /** 直播时间 */
        liveTime: [{ required: true, message: '请选择直播时间', trigger: 'change' }],
        /** 左队伍信息 */
        teamA: [{
          required: true, trigger: 'blur',
          validator: (rule, value, callback) => {
            if (!value) {
              callback(new Error('请输入左队伍信息'));
            } else {
              /** 再去验证左队伍得分 队伍得分不是必填*/
              if (this.liveForm.teamAScore && !/^[0-9]\d*$/.test(this.liveForm.teamAScore)) {
                callback(new Error('请输入整数的左队伍得分'));
              } else {
                /** 再去验证左队伍图标 */
                if (!this.liveForm.teamAImg) {
                  callback(new Error('请上传左队伍图片'));
                } else {
                  callback();
                }
                callback();
              }
              callback();
            }
          }
        }],
        /** 右队伍信息 */
        teamB: [{
          required: true, trigger: 'blur',
          validator: (rule, value, callback) => {
            if (!value) {
              callback(new Error('请输入右队伍信息'));
            } else {
              /** 再去验证右队伍得分 */
              if (this.liveForm.teamBScore && !/^[0-9]\d*$/.test(this.liveForm.teamBScore)) {
                callback(new Error('请输入整数的右队伍得分'));
              } else {
                /** 再去验证右队伍图标 */
                if (!this.liveForm.teamBImg) {
                  callback(new Error('请上传右队伍图片'));
                } else {
                  callback();
                }
                callback();
              }
              callback();
            }
          }
        }],
        /** 显示顺序 */
        // displayOrder: [{
        //   required: false, message: '请输入显示顺序', trigger: 'blur',
        //   validator: (rule, value, callback) => {
        //     /** 只支持正整数 */
        //     if (!/^[1-9]\d*$/.test(value)) {
        //       callback(new Error('请输入正整数'));
        //     } else {
        //       callback();
        //     }
        //   }
        // }],
        /** 描述 */
        description: [{ required: false, message: '请输入描述', trigger: 'blur' }],
        /** 关联应用 */
        thirdPartyAppId: [{ required: true, message: '请选择关联应用', trigger: 'change' }],
        /** 单片跳转链接 */
        /** 安卓scheme */
        androidScheme: [{ required: true, message: '请输入安卓scheme', trigger: 'blur' }],
        /** 安卓app_link */
        androidAppLink: [{ required: true, message: '请输入安卓app_link', trigger: 'blur' }],
        /** 安卓pad_scheme */
        androidPadScheme: [{ required: false, message: '请输入安卓pad_scheme', trigger: 'blur' }],
        /** ios_scheme */
        iosScheme: [{
          required: false, trigger: 'blur',
          /** ios_scheme和ios_app_link至少填写一个 */
          validator: (rule, value, callback) => {
            if (!value && !this.liveForm.appLink) {
              callback(new Error('ios_scheme和ios_app_link至少填写一个'));
            } else {
              callback();
            }
          }
        }],
        /** ios_app_link */
        appLink: [{
          required: false, trigger: 'blur',
          /** ios_scheme和ios_app_link至少填写一个 */
          validator: (rule, value, callback) => {
            if (!value && !this.liveForm.iosScheme) {
              callback(new Error('ios_scheme和ios_app_link至少填写一个'));
            } else {
              callback();
            }
          }
        }],
        /** ipad_scheme */
        ipadScheme: [{ required: false, message: '请输入ipad_scheme', trigger: 'blur' }],
        /** 备注 */
        remark: [{ required: false, message: '请输入备注', trigger: 'blur' }],
        /** 状态 */
        status: [{ required: true, message: '请选择状态', trigger: 'change' }],
        /** 生效模式 */
        effectMode: [
          { required: true, message: "请选择生效模式", trigger: "blur" },
        ],
        /** 生效时间 */
        effectTime: [
          {
            required: true,
            validator: (rule, value, callback) => {
              console.log("生效时间", value);
              if (value === undefined || value.length === 0) {
                callback(new Error("请选择生效时间"));
              } else {
                // 校验开始时间，大于当前时间
                if (value[0]) {
                  // 将字符串格式的开始时间转换为Date对象
                  const startTime = new Date(value[0]);

                  // 检查转换是否成功，且开始时间是否大于当前时间
                  if (
                    isNaN(startTime.getTime()) ||
                    startTime.getTime() < Date.now()
                  ) {
                    callback(new Error("生效开始时间不能小于当前时间"));
                  }
                }
                if (value[1]) {
                  // 将字符串格式的结束时间转换为Date对象
                  const endTime = new Date(value[1]);

                  // 检查转换是否成功，且结束时间是否大于开始时间
                  if (
                    isNaN(endTime.getTime()) ||
                    endTime.getTime() < new Date(value[0]).getTime()
                  ) {
                    callback(new Error("生效结束时间不能小于开始时间"));
                  }
                }
                callback();
              }
            },
            trigger: "blur",
          },
        ],
      },
    };
  },

  methods: {
    /** 上传图片校验 */
    fileCheck(file) {
      // 判断类型
      if (file.type !== "image/jpeg" && file.type !== "image/png") {
        Message.error("目前只支持jpg/png图片");
        return false;
      }
      // 判断大小
      if (file.size > 1024 * 1024 * 5) {
        Message.error("不能上传超过2M的图片");
        return false;
      }
    },
    /** 上传图片的方法 */
    async upload(params, type) {
      const file = params.file;
      let liveForm = new FormData();
      liveForm.append("file", file);
      try {
        const { data } = await axios.post(
          "/lebo-resource/oss/endpoint/put-file?code=lebotob",
          liveForm,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        console.log("上传图片的响应", data);
        const result = data.data;
        if (data.code === 200) {
          /** 上传成功 */
          /** 赋值 */
          if (type === 1) {
            this.liveForm.teamAImg = result.link;
            this.$refs.liveForm.validateField("teamA");
          } else {
            this.liveForm.teamBImg = result.link;
            this.$refs.liveForm.validateField("teamB");
          }
          /** 提示用户 */
          Message.success("上传成功");
        }
      } catch (error) {
        throw new Error(error);
      }
    },
    /** 获得表单数据的方法 */
    getForm(row) {
      console.log("获得的表单数据", row);
      const formData = formatEditLive(row);
      console.log("格式化后的表单数据", formData);
      this.$set(this, "liveForm", formData)
    },
    /** 保存 */
    save() {
      this.$refs.liveForm.validate(async (valid) => {
        if (valid) {
          console.log("表单验证通过", this.liveForm);
          /** 校验图片宽度 */
          if (!validateTeamAImageWidth(this.liveForm)) {
            return;
          }
          /** merge 对象防止响应式丢失 */
          _.merge(this.liveForm, updateTeamAImgUrl(this.liveForm))
          if (!validateTeamBImageWidth(this.liveForm)) {
            return;
          }
          _.merge(this.liveForm, updateTeamBImgUrl(this.liveForm))
          const param = formatAddLive(this.liveForm);
          console.log("格式化后的参数", param);
          try {
            const { data } = await updateListContent(param);
            if (data.code === 200) {
              Message.success("保存成功");
              this.$emit('reload');
              this.cancel();
            } else {
              Message.error(data.message);
            }
          } catch (error) {
            throw new Error(error);
          }
        } else {
          console.log("表单验证失败");
        }
      });
    },
    /** 关闭的方法 */
    cancel() {
      this.$refs.liveForm.clearValidate();
      this.reset();
      this.$emit("close");
    },
    /** 重置表单数据的方法 */
    reset() {
      /** 直播时间 */
      this.liveForm.liveTime = [];
      /** 左队伍信息 */
      this.liveForm.teamA = '';
      /** 左队伍得分 */
      this.liveForm.teamAScore = '';
      /** 左队伍图标 */
      this.liveForm.teamAImg = '';
      /** 左队伍图片宽度 */
      this.liveForm.teamAImgWidth = '';
      /** 左队伍图片选择宽度 */
      this.liveForm.teamAImgSelectWidth = '300';
      /** 右队伍信息 */
      this.liveForm.teamB = '';
      /** 右队伍得分 */
      this.liveForm.teamBScore = '';
      /** 右队伍图标 */
      this.liveForm.teamBImg = '';
      /** 右队伍图片宽度 */
      this.liveForm.teamBImgWidth = '';
      /** 右队伍图片选择宽度 */
      this.liveForm.teamBImgSelectWidth = '300';
      /** 显示顺序 */
      this.liveForm.displayOrder = '';
      /** 描述 */
      this.liveForm.description = '';
      /** 关联应用 */
      this.liveForm.thirdPartyAppId = '';
      /** 单片跳转链接 */
      /** 安卓scheme */
      this.liveForm.androidScheme = '';
      /** 安卓app_link */
      this.liveForm.androidAppLink = '';
      /** 安卓pad_scheme */
      this.liveForm.androidPadScheme = '';
      /** ios_scheme */
      this.liveForm.iosScheme = '';
      /** ios_app_link */
      this.liveForm.appLink = '';
      /** ipad_scheme */
      this.liveForm.ipadScheme = '';
      /** 备注 */
      this.liveForm.remark = '';
      /** 状态 */
      this.liveForm.status = null;
      /** 生效模式 1：立即生效；2：指定时间生效 */
      this.liveForm.effectMode = "";
      /** 生效时间 */
      this.liveForm.effectTime = [];
      this.liveForm.id = null;
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .el-textarea__inner {
  min-height: 70px !important;
}

.teamInfo {
  display: flex;
  align-items: flex-end;

  .left {
    margin-right: 20px;
    display: flex;
    flex-direction: column;
  }

  .right {
    flex: 1;

    .custom-width {
      position: relative;
    }

    .tip-icon {
      position: absolute;
      top: 0;
      left: 140px;
    }
  }
}

// .link {
//   position: relative;
//   height: 200px;
// }

.link-container {
  // position: absolute;
  // left: -100px;
  padding: 20px;
  // width: 100%;
  background-color: #f5f5f5;
}

//^ ^--------------上传图片样式-------------^ ^
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

::v-deep .avatar-uploader .el-upload:hover {
  border-color: #409eff !important;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  background-color: #f5f7fa;
  width: 150px;
  height: 150px;
  line-height: 150px;
  text-align: center;
}

.avatar {
  width: 150px;
  height: 150px;
  display: block;
}
</style>